import React, { useEffect, useState } from 'react';
import { ModuleItemInterface } from '../../../types/home.type';
import ImageComponent from '../ImageComponent';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { useNavigate, useParams } from 'react-router-dom';

interface BannerSectionProps {
  module: ModuleItemInterface;
}

const BannerSection: React.FC<BannerSectionProps> = ({ module }) => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 768
  );
  const navigate = useNavigate(); // Initialize navigate
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const swiperContainer = document.querySelector('.hero-banner .swiper') as HTMLElement | null;
    let swiperInstance: Swiper | null = null;
    if (swiperContainer) {
      swiperInstance = new Swiper(swiperContainer, {
        direction: 'horizontal',
        loop: true,
        speed: 600, // transition speed for effect
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
          renderBullet: (index: number, className: string) => {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
      });
    }
    return () => {
      if (swiperInstance && typeof swiperInstance.destroy === 'function') {
        swiperInstance.destroy(true, true);
      }
    };
  }, []);

  const isMobile = windowWidth < 768;

  return (
    <div className="hero-banner rounded-b-xl overflow-hidden">
      <div className="swiper-slider">
        <div className="swiper">
          <div className="swiper-wrapper">
            {Array.isArray(module.items) &&
              module.items.map((item: any, index: number) => (
                <div key={item.id} className="swiper-slide relative" onClick={() => {
                  if (item.slug && item.slug.startsWith('https')) {
                    window.open(item.slug, '_blank');
                  } else if (item.slug) {
                    navigate(`/${lang}/${item.slug}`);
                  }
                }}>
                  <div className="relative md:aspect-banner overflow-hidden rounded-lg">
                    <ImageComponent
                      src={isMobile && item.images_mobile ? item.images_mobile : item.images}
                      alt={item.title || 'Banner'}
                      className="object-cover w-full h-full"
                      priority={index === 0}
                      width={1920}
                      height={1080}
                      loading={index === 0 ? 'eager' : 'lazy'}
                    />
                    <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
                      <p className="hero-title">
                        {item.title}
                        <br />
                        <span className="subtitle">{item.description || ''}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="swiper-pagination"></div> {/* Pagination dots displayed by Swiper */}
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
